export function Footer() {
  return (
    <footer className="h-10 flex items-center justify-between gap-2 px-4 border-t border-bordercolor bg-white">
      <p className="text-sm text-grey">
        Copyright © {new Date().getFullYear()} All Rights Reserved Zoracom
      </p>
      <span className="space-x-4">
        <a
          href="/terms"
          className="text-sm text-grey hover:text-primary duration-200"
        >
          Terms
        </a>
        <a
          href="/privacy"
          className="text-sm text-grey hover:text-primary duration-200"
        >
          Privacy Policy
        </a>
      </span>
    </footer>
  );
}
